// extracted by mini-css-extract-plugin
module.exports = {"title":"title-SG_fA6q-","cut":"cut-1Q3LEAsn","title_l":"title_l-DruU13ay","middle":"middle-3GMA0Ba9","title_r":"title_r-iWu2ydCU"};